import { Modal } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AvailableDocumentList from './AvailableDocumentList';
import { StyledT } from './AvailableDocumentsModal.styles';

export interface AvailableDocumentsModalProps { }

const AvailableDocumentsModal: FC<AvailableDocumentsModalProps> = () => {
  const { t } = useTranslation('Documents');

  return (
    <Modal name="availableDocumentsModal">
      <StyledT>{t('modalTitle')}</StyledT>
      <AvailableDocumentList />
    </Modal>
  );
};
export default AvailableDocumentsModal;
